<template>
  <create-dialog
    width="80%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @handleOpen="handleOpen"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div :class="`col-12 col-sm-6 col-lg-2`">
          <fg-input
            type="text"
            :label="`${$t('common_words.code')}: *`"
            v-model="model.code"
            name="common_words.code"
            v-validate="modelValidations.code"
            :error="getError('common_words.code', true)"
            placeholder="..."
            @click="handleClickOnCode()"
          >
          </fg-input>
        </div>
        <div :class="`col-12 col-sm-6 col-lg-4`">
          <fg-input
            type="text"
            :label="`${$t('common_words.name')}: *`"
            v-model="model.name"
            name="common_words.name"
            v-validate="modelValidations.name"
            :error="getError('common_words.name', true)"
            placeholder=" ..."
          >
          </fg-input>
        </div>
        <div :class="`col-12 col-sm-6 col-lg-3`">
          <label>
            {{ $t('common_words.value') }}
            {{ `${model.percent ? `(%)` : `($)`}` }}: *
            <el-checkbox class="pl-2 mb-0" v-model="model.percent">{{
              $t('common_words.percentual')
            }}</el-checkbox>
          </label>
          <br />
          <fg-input
            class="shadow-sm required-price"
            type="number"
            v-model="model.price"
            v-validate="modelValidations.price"
            name="common_words.minimum"
            :error="getError('common_words.minimum', true)"
            placeholder=" ..."
          >
          </fg-input>
        </div>
        <div :class="`col-12 col-sm-6 col-lg-3`">
          <div class="form-group has-label">
            <label for="">{{ $t('labor.hour_format') }}: *</label>
            <br />
            <el-select
              filterable
              class="select-primary mb-3 shadow-sm required-hour_type"
              v-model="model.hour_type"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="item in optionsHourType"
                :key="item.id + item.value"
                :label="item.value"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-if="businesses.length > 2" class="col-12">
          <div class="form-group has-label">
            <label>{{ $t('common_words.companies2') }} *</label>
            <br />
            <el-select
              collapse-tags
              @change="selectAllFromSelect('model.business_id', businesses)"
              clearable
              multiple
              filterable
              class="select-primary custom-width-select shadow-sm required-business"
              size="large"
              v-model="model.business_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in businesses"
                class="select-primary selected-all"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create-time',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [MixinDialog, MixinForm, MixinPermissions, MixinValidations],
  data() {
    return {
      businesses: [],
      model: {
        name: null,
        price: null,
        percent: true,
        hour_type: null,
        business_id: [],
        route: null,
        code: null,
      },
      modelValidations: {
        code: { required: true },
        name: { required: true },
        price: { required: true, min_value: 1 },
      },
      dataFormate: [
        { id: 'entero', value: 'Entero' },
        { id: 'decimal', value: 'Decimal' },
      ],
    };
  },
  computed: {
    optionsHourType() {
      return [
        { id: i18n.t('labor.ordinary_dayshift'), value: 'Ordinaria Diurna' },
        { id: i18n.t('labor.holiday_dayshift'), value: 'Festiva Diurna' },
        { id: i18n.t('labor.sunday_dayshift'), value: 'Dominical Diurna' },
        {
          id: i18n.t('labor.ordinary_nightshift'),
          value: 'Ordinaria Nocturna',
        },
        { id: i18n.t('labor.holiday_nightshift'), value: 'Festiva Nocturna' },
        { id: i18n.t('labor.sunday_nightshift'), value: 'Dominical Nocturna' },
      ];
    },
  },
  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    formatNumber(value) {
      return Formatter.formatNumber(Number(value));
    },
    handleClickOnCode() {
      if (!isset(this.model.code) && !this.model.isEdit) {
        const tableCode = JSON.parse(sessionStorage.getItem('tableCode'));
        this.codeGenerator(i18n.t('labor.hours_type'), tableCode);
      }
    },
    handleOpen() {
      if (!this.model.isEdit) {
        this.model.business_id = this.selectElementsAsignFromModel(
          1,
          this.model.business_id,
          this.businesses
        );
      }
    },
    validateForm() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.price)) {
            return this.validationInputsRequired('price');
          } else if (!isset(this.model.hour_type)) {
            return this.validationInputsRequired('hour_type');
          } else if (!isset(this.model.business_id)) {
            return this.validationInputsRequired('business');
          } else {
            this.model.price_format = this.model.percent ? '%' : '$';
            this.$emit('addEdit', this.model);
            return true;
          }
        }
      });
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const { id, name, price, price_format, code, businesses, hour_type } =
        JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        id,
        name,
        price,
        percent: price_format === '%',
        price_format,
        code,
        hour_type,
        business_id: businesses.map((business) => business.id),
        isEdit: true,
      };
      this.errors.clear();
      sessionStorage.removeItem('editForm');
    }
  },
  created() {
    if (this.isIndex()) {
      Promise.all([Axios.getMasters('businesses/only')])
        .then((response) => {
          const [response_businesses] = response;
          this.businesses = this.concatAll(response_businesses.data.data);
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showMessageAccess();
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
  },
};
</script>
